<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '1.5rem',
    },
    height: {
      type: [String, Number],
      default: '1.5rem',
    },
    title: {
      type: String,
      default: 'Text format hyperlink',
    },
    isDecorative: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ariaLabel() {
      return this.isDecorative ? null : this.title
    },
  },
}
</script>
<template>
  <svg
    role="img"
    :aria-label="ariaLabel"
    :aria-hidden="isDecorative"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    :style="{ width, height }"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M10.467 9.601a3.57 3.57 0 0 0-2.665-1.199H6.603c-2.77 0-4.5 2.998-3.116 5.397a3.6 3.6 0 0 0 3.116 1.799h1.2a3.58 3.58 0 0 0 2.664-1.2m3.066-4.797a3.57 3.57 0 0 1 2.664-1.199h1.2c2.77 0 4.5 2.998 3.116 5.397a3.6 3.6 0 0 1-3.116 1.799h-1.2a3.58 3.58 0 0 1-2.664-1.2M7.802 12h8.395"/>
  </svg>
</template>
